import * as React from "react";
import { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

function LocationSelect({ id, label, onChange }) {
  const [citiesArray, setCitiesArray] = useState([]);

  useEffect(() => {
    fetch("https://3.77.42.136.nip.io/locations")
      .then((response) => response.json())
      .then((data) => {
        const cities = data.map(({ locationName: label, code }) => ({
          label,
          code,
        }));
        setCitiesArray(cities);
      });
  }, []);

  return (
    <Autocomplete
      style={{ marginTop: "10px", fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      fontStyle: 'normal' }}
      id={id}
      className="location-select"
      label={label}
      options={citiesArray}
      getOptionLabel={(option) => `${option.label} (${option.code})`}
      onChange={(event, value) => {
        if (value) {
          onChange(value.code);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "25px 25px 25px 25px",
            },
            "& .MuiInputLabel-root": {
              fontWeight: "bold",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: "initial",
              },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "initial",
            },
          }}
        />
      )}
    />
  );
}

export default LocationSelect;